export const LogoPage = () => {
    return (
        <div className={'logo'}></div>
    )
}